module.exports = __webpack_public_path__ + "img/server_blue.83657ab7.png";